import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import { INascarViewModel } from 'app/models/INascarViewModel';
import { IOrgUserRaceFilter } from 'app/models/IOrgUserRaceFilter';
import { ISeason } from 'app/models/ISeason';
import { BaseService } from 'app/services/base.service';
import { IRace } from '../models/IRace';

let config = require('../../config').appConfig;

@Injectable()
export class NascarService {
    // public nascar: INascarViewModel;
    constructor(private baseService: BaseService) {

    }

    getCurrentOrgUserRace(entity: any) {
        return this.baseService.sendHttpPost('/nascar/currentorguserrace', entity);
    }

    getCurrentOrgUserRaceByUser(filter: IOrgUserRaceFilter) {
        return this.baseService.sendHttpPost('/nascar/currentorguserrace', filter);
    }

    updateCurrentOrgUserRace(nascarRace: INascarViewModel) {
        return this.baseService.sendHttpPost('/nascar/updateorguserrace', nascarRace);

    }
    getCurrentRaceResults() {
        return this.baseService.sendHttpGet('/nascar/getcurrentraceresults');
    }

    getSeasons() {
        return this.baseService.sendHttpGet('/nascar/getSeasons');
    }

    getWeeks(season: any): any {
        return this.baseService.sendHttpPost('/nascar/getWeeks', season);
    }

    getRaceResults(model: IOrgUserRaceFilter) : any {
        return this.baseService.sendHttpPost('/nascar/getraceresults', model);
    }

    getRaceSeasonResults(model: IOrgUserRaceFilter) : any {
        return this.baseService.sendHttpPost('/nascar/getraceseasonresults', model);
    }

    getCanMakeChanges(): any {
        return this.baseService.sendHttpGet('/nascar/getcanmakechanges');
    }

    getLastRace() {
        return this.baseService.sendHttpGet('/nascar/getlastrace');
    }

    getCurrentNascarRace(): any {
        return this.baseService.sendHttpGet('/nascar/getCurrentNascarRace');
    }
}



// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/services/nascar.service.ts